/* eslint-disable no-console */

import { register } from 'register-service-worker'

if (import.meta.env.PROD) {
  register('sw.js', {
    ready() {
      console.log('App is being served from cache by a service worker.\n' + 'For more details, visit https://goo.gl/AFskqB')
    },
    registered() {
      console.log('Service worker has been registered.')
    },
    cached() {
      console.log('Content has been cached for offline use.')
    },
    updatefound() {
      console.log('New content is downloading.')
    },
    updated(reg) {
      console.log('New version available. Reloading...')

      if (reg.waiting) {
        reg.waiting.postMessage({ type: 'SKIP_WAITING' })

        reg.waiting.addEventListener('statechange', event => {
          if (event.target.state === 'activated') {
            window.location.reload(true)
          }
        })
      }
    },
    offline() {
      console.log('No internet connection found. App is running in offline mode.')
    },
    error(error) {
      console.error('Error during service worker registration:', error)
    }
  })

  // Escuta mensagens do SW para forçar reload em todas as abas
  navigator.serviceWorker.addEventListener('message', event => {
    if (event.data && event.data.type === 'NEW_VERSION') {
      console.log('New version detected. Reloading...')
      window.location.reload()
    }
  })
}
